var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirdedExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0140CD",
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-2.249-5.205c.048 1.228 1.056 2.201 2.285 2.205h.04c.595-.01 1.16-.259 1.57-.69.408-.433.626-1.01.604-1.605-.046-1.23-1.054-2.203-2.285-2.205h-.04c-.594.01-1.16.26-1.569.691-.408.432-.626 1.01-.605 1.604zM12 3c-.828 0-1.5.672-1.5 1.5v8.25c0 .828.672 1.5 1.5 1.5s1.5-.672 1.5-1.5V4.5c0-.828-.672-1.5-1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirdedExclamation);
export default __webpack_public_path__ + "static/media/girded-exclamation.f0b9b12563f830447b4df4c10f49ec2a.svg";
export { ForwardRef as ReactComponent };